import { ShoppingCart } from 'lucide-react'
import { cn } from '@utils'
import { useCartStore } from '@stores/useCartStore'
import { openCrossSellCart } from '../hooks/useCrossSellCart'
import { isCrossSellLine } from '../utils/crossSell'

interface OmpCrossSellCartButtonProps {
  // Matches the nav layout it sits in: the top bar, a side block, or the mobile header.
  variant: 'top' | 'sidebar' | 'compact'
}

const LABEL = 'Cart'

// The header's way back into the cross-sell cart. The nav renders it only while
// useCrossSellCartVisible() is true.
const OmpCrossSellCartButton = ({ variant }: OmpCrossSellCartButtonProps) => {
  const count = useCartStore(s => s.cart.reduce((sum, item) => (isCrossSellLine(item) ? sum + item.quantity : sum), 0))
  const ariaLabel = `${LABEL}, ${count} ${count === 1 ? 'item' : 'items'}`

  const icon = (
    <span className="omp-cart-btn-icon">
      <ShoppingCart size={variant === 'sidebar' ? 22 : 20} strokeWidth={1.75} aria-hidden="true" />
      <span className="omp-cart-btn-badge" aria-hidden="true">
        {count}
      </span>
    </span>
  )

  if (variant === 'sidebar') {
    return (
      <button
        type="button"
        className="omp-nav-block omp-cart-btn omp-cart-btn-sidebar"
        aria-label={ariaLabel}
        onClick={openCrossSellCart}>
        {icon}
        <span className="omp-nav-label">{LABEL}</span>
      </button>
    )
  }

  return (
    <button
      type="button"
      className={cn('omp-cart-btn', variant === 'top' ? 'omp-topnav-item omp-cart-btn-top' : 'omp-cart-btn-compact')}
      aria-label={ariaLabel}
      title={LABEL}
      onClick={openCrossSellCart}>
      {icon}
    </button>
  )
}

export default OmpCrossSellCartButton
